module.exports = __webpack_public_path__ + "media/styles/images/svg/arrow-right-gray-dark-d3b1f3324da7ff751639a1aea762e2b5.svg";